import { Endpoint } from "./BaseEndpoint";

export class TagManagerEndpoint extends Endpoint {
  constructor() {
    super("tag_manager_args");
  }
}
